import { render, staticRenderFns } from "./QueryTaxonomizado.vue?vue&type=template&id=6671afed&"
import script from "./QueryTaxonomizado.vue?vue&type=script&lang=js&"
export * from "./QueryTaxonomizado.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports